import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import { useNotifications } from "reapop";

export const GetProcessWhatIsSection = () => {
  return useQuery({
    queryKey: ["get-process-what-is-section"],
    queryFn: () => client.processWhatIsSection.getSection(),
  });
};

export const UpdateProcessWhatIsSection = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();

  return useMutation({
    mutationFn: (data) => client.processWhatIsSection.updateSection(data),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "Section updated successfully!", "success");
        queryClient.invalidateQueries(["get-process-what-is-section"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to update section!", "error");
    },
  });
};
